/* =========================================================
   DABIRA AROMA — Theme script
   Mobile menu, header dropdown, predictive search, AJAX cart
   drawer, sticky add-to-cart, PDP gallery + zoom.
   ========================================================= */

(function () {
  'use strict';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------- Mobile menu ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.hasAttribute('hidden');
      if (isOpen) { mobileMenu.setAttribute('hidden', ''); menuToggle.setAttribute('aria-expanded', 'false'); }
      else { mobileMenu.removeAttribute('hidden'); menuToggle.setAttribute('aria-expanded', 'true'); }
    });
  }

  /* ---------- Nav dropdown — keyboard support ---------- */
  $$('[data-has-dropdown]').forEach(item => {
    const link = item.querySelector('.site-nav__link');
    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        item.classList.toggle('is-open');
        link.setAttribute('aria-expanded', item.classList.contains('is-open'));
      }
      if (e.key === 'Escape') {
        item.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-has-dropdown]')) {
      $$('[data-has-dropdown].is-open').forEach(el => el.classList.remove('is-open'));
    }
  });

  /* ---------- Predictive search ---------- */
  const searchOverlay = $('[data-predictive-search]');
  const searchToggle  = $('[data-search-toggle]');
  const searchInput   = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  let searchTimer = null;

  const openSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.removeAttribute('hidden');
    document.body.classList.add('is-search-open');
    setTimeout(() => searchInput && searchInput.focus(), 50);
  };
  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('hidden', '');
    document.body.classList.remove('is-search-open');
  };
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  $$('[data-search-close]').forEach(el => el.addEventListener('click', closeSearch));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeCart(); closeZoom(); }
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
  });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(() => fetchPredictive(q), 220);
    });
  }

  function fetchPredictive(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(data => renderPredictive(data, query))
      .catch(() => { searchResults.innerHTML = '<p class="predictive-search__empty">Search unavailable. Try again.</p>'; });
  }

  function renderPredictive(data, query) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (products.length === 0) {
      searchResults.innerHTML = `<p class="predictive-search__empty">No matches for "${escapeHtml(query)}". Try a single word like "amber" or "candle".</p>`;
      return;
    }
    const html = `
      <p class="predictive-search__hint">${products.length} ${products.length === 1 ? 'product' : 'products'}</p>
      <div class="predictive-search__results-grid">
        ${products.map(p => `
          <a href="${p.url}" class="predictive-search__result">
            <div class="predictive-search__result-image">
              ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
            </div>
            <div>
              <div class="predictive-search__result-title">${escapeHtml(p.title)}</div>
              <div class="predictive-search__result-price">${p.price || ''}</div>
            </div>
          </a>
        `).join('')}
      </div>`;
    searchResults.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  }

  /* ---------- AJAX Cart drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartToggle = $('[data-cart-toggle]');
  const cartBody   = $('[data-cart-body]');
  const cartCount  = $('[data-cart-count]');

  const openCart  = () => { if (!cartDrawer) return; cartDrawer.removeAttribute('hidden'); document.body.classList.add('is-drawer-open'); };
  const closeCart = () => { if (!cartDrawer) return; cartDrawer.setAttribute('hidden', '');  document.body.classList.remove('is-drawer-open'); };

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));

  // Intercept add-to-cart on PDP
  const productForms = $$('form[action="/cart/add"], form[action$="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(r => r.json())
        .then(() => refreshCart().then(() => { openCart(); }))
        .catch(() => { alert('Sorry — that did not add. Try again.'); })
        .finally(() => {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  });

  function refreshCart() {
    return fetch('/?section_id=cart-drawer-fragment', { headers: { 'Accept': 'text/html' } })
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(html => {
        // Fallback: just refetch /cart and rebuild from JSON if section render isn't available
        return refreshCartViaJson();
      })
      .catch(() => refreshCartViaJson());
  }

  function refreshCartViaJson() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          if (cart.item_count > 0) cartCount.removeAttribute('hidden');
          else cartCount.setAttribute('hidden', '');
        }
        if (cartBody) renderCartBody(cart);
        return cart;
      });
  }

  function renderCartBody(cart) {
    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your bag is empty.</p>
          <a href="/collections/all" class="btn btn--primary">Shop the collection</a>
        </div>`;
      return;
    }
    const items = cart.items.map(item => `
      <li class="cart-drawer__item" data-line-item-key="${item.key}">
        <a href="${item.url}" class="cart-drawer__item-image">
          ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
        </a>
        <div class="cart-drawer__item-details">
          <a href="${item.url}" class="cart-drawer__item-title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : ''}
          <div class="cart-drawer__item-row">
            <div class="cart-drawer__item-qty">
              <button type="button" class="cart-drawer__qty-btn" data-qty-change="-1" data-line="${item.key}">−</button>
              <span class="cart-drawer__qty-value">${item.quantity}</span>
              <button type="button" class="cart-drawer__qty-btn" data-qty-change="1" data-line="${item.key}">+</button>
            </div>
            <span class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-drawer__item-remove" data-cart-remove data-line="${item.key}">Remove</button>
        </div>
      </li>`).join('');

    cartBody.innerHTML = `
      <ul class="cart-drawer__items">${items}</ul>
      <footer class="cart-drawer__footer">
        <p class="cart-drawer__subtotal"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></p>
        <p class="cart-drawer__shipping-note">Shipping &amp; taxes calculated at checkout.</p>
        <a href="/cart" class="btn btn--ghost cart-drawer__view-cart">View bag</a>
        <a href="/checkout" class="btn btn--primary cart-drawer__checkout">Checkout</a>
      </footer>`;

    bindCartActions();
  }

  function bindCartActions() {
    $$('[data-qty-change]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.line;
        const delta = parseInt(btn.dataset.qtyChange, 10);
        const itemEl = btn.closest('[data-line-item-key]');
        const valEl = itemEl.querySelector('.cart-drawer__qty-value');
        const newQty = Math.max(0, parseInt(valEl.textContent, 10) + delta);
        updateLineItem(key, newQty);
      });
    });
    $$('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', () => updateLineItem(btn.dataset.line, 0));
    });
  }

  function updateLineItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(() => refreshCartViaJson());
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- PDP gallery — thumb click swaps main image ---------- */
  $$('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = $('[data-gallery-main] img');
      if (!main) return;
      main.setAttribute('src', thumb.dataset.fullSrc);
      main.setAttribute('alt', thumb.dataset.alt || '');
      $('[data-gallery-main]').setAttribute('data-zoom-src', thumb.dataset.zoomSrc);
      $$('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* ---------- PDP zoom lightbox ---------- */
  const zoomTrigger  = $('[data-zoom-trigger]');
  const zoomLightbox = $('[data-zoom-lightbox]');
  const zoomImage    = $('[data-zoom-image]');
  if (zoomTrigger && zoomLightbox) {
    zoomTrigger.addEventListener('click', () => {
      const main = zoomTrigger.querySelector('img');
      const zoomSrc = zoomTrigger.dataset.zoomSrc || (main && main.dataset.zoomSrc) || (main && main.src);
      zoomImage.src = zoomSrc;
      zoomImage.alt = main ? main.alt : '';
      zoomLightbox.removeAttribute('hidden');
    });
    $$('[data-zoom-close]').forEach(el => el.addEventListener('click', closeZoom));
    zoomLightbox.addEventListener('click', (e) => {
      if (e.target === zoomLightbox || e.target === zoomImage) closeZoom();
    });
  }
  function closeZoom() { if (zoomLightbox) zoomLightbox.setAttribute('hidden', ''); }

  /* ---------- PDP sticky add-to-cart bar ---------- */
  const stickyBar = $('[data-sticky-bar]');
  const mainAtc = $('[data-add-to-cart]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });
    obs.observe(mainAtc);
  }

  /* ---------- Cart page: live update ---------- */
  $$('.cart__item-quantity').forEach(input => {
    let t;
    input.addEventListener('change', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const form = input.closest('form');
        if (form) form.submit();
      }, 350);
    });
  });

  /* ---------- Recover password ---------- */
  const recoverLink = $('#RecoverPassword');
  const recoverEl   = $('#recover');
  if (recoverLink && recoverEl) {
    recoverLink.addEventListener('click', (e) => {
      e.preventDefault();
      recoverEl.scrollIntoView({ behavior: 'smooth' });
      const firstInput = recoverEl.querySelector('input');
      if (firstInput) firstInput.focus();
    });
  }

  /* ---------- Initial cart bind (in case drawer was server-rendered) ---------- */
  bindCartActions();

  /* ---------- Hero carousel ---------- */
  $$('[data-hero-carousel]').forEach((root) => {
    const slides = $$('[data-hero-slide]', root);
    if (slides.length <= 1) return;

    const dots      = $$('[data-hero-dot]', root);
    const prevBtn   = $('[data-hero-prev]', root);
    const nextBtn   = $('[data-hero-next]', root);
    const autoplay  = root.getAttribute('data-autoplay') === 'true';
    const interval  = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    const reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.style.setProperty('--hero-interval', interval + 'ms');

    let current = 0;
    let timer   = null;
    let paused  = false;

    function go(to) {
      const next = (to + slides.length) % slides.length;
      if (next === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[next].classList.add('is-active');
      slides[next].removeAttribute('aria-hidden');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[next]) {
        dots[next].classList.add('is-active');
        dots[next].setAttribute('aria-selected', 'true');
      }
      current = next;
      // Restart the dot fill animation by re-applying the class.
      if (autoplay && !reduced && dots[next]) {
        const fill = dots[next].querySelector('.hero-carousel__dot-fill');
        if (fill) {
          fill.style.animation = 'none';
          // Force reflow so animation restarts cleanly.
          // eslint-disable-next-line no-unused-expressions
          fill.offsetHeight;
          fill.style.animation = '';
        }
      }
    }

    function start() {
      if (!autoplay || reduced || paused) return;
      stop();
      timer = window.setInterval(() => go(current + 1), interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { go(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { go(current + 1); start(); });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.getAttribute('data-index'), 10) || 0;
        go(target);
        start();
      });
    });

    // Pause on hover / focus
    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin',   () => { paused = true; stop(); });
    root.addEventListener('focusout',  (e) => {
      if (!root.contains(e.relatedTarget)) { paused = false; start(); }
    });

    // Keyboard navigation
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { go(current - 1); start(); }
      if (e.key === 'ArrowRight') { go(current + 1); start(); }
    });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    // Touch swipe
    let touchStartX = null;
    root.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) go(current + 1); else go(current - 1);
        start();
      }
      touchStartX = null;
    }, { passive: true });

    start();
  });
})();
